/* Scripts: Utilities */
import { lightbox } from '@/scripts/utilities/lightbox';
import { createHashFocus } from '@/scripts/utilities/hash-focus';
import { events } from '@/scripts/utilities/events';
import { externalLinks } from '@/scripts/utilities/external-links';
import { videoAnalytics } from '@/scripts/utilities/video-analytics';

/* Scripts: Modules */
import blanks from '@/scripts/modules/blanks';
import questions from '@/scripts/modules/questions';
import enlarge from '@/scripts/modules/enlarge';
import report from '@/scripts/modules/report';
import root from '@/scripts/modules/root';
import search from '@/scripts/modules/search';
import { AccordionManager } from '@/scripts/modules/accordions';
import NavigationDropdown from '@/scripts/modules/navigation-dropdown';

/* Initialize: Modules */
blanks.init();
questions.init();
enlarge.init();
report.init();
root.init();
search.init();

/* Styles */
import './styles/main.scss';

/* Ready */
window.addEventListener('DOMContentLoaded', () => {
  console.log('Starting Smarter: Assets Loaded');

  /* Initialize: Utilities */
  lightbox.init();
  videoAnalytics.init();
  createHashFocus();
  events.init();
  externalLinks.init({ treatSubdomainsAsInternal: true });

  // Initialize with default options (finds all .accordion elements)
  const accordionManager = new AccordionManager();
  accordionManager.init();

  // Initialize navigation dropdown functionality
  NavigationDropdown.init();
});
